module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-regular-400.3e332211.woff2";